import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        primary: '#4b9ed6',
        secondary: '#6bc5ef',
        accent: '#202020',
        error: '#b71c1c',
      }
    }
  },
  lang: {
    locales: {
      sl: {
        dataIterator: {
          noDataText: 'Ni podatkov na voljo',
          loadingText: 'Nalaganje elementov...',
        },
        dataTable: {
          itemsPerPageText: 'Vrstic na stran:',
          ariaLabel: {
            sortDescending: 'Razvrščeno padajoče.',
            sortAscending: 'Razvrščeno naraščajoče.',
            sortNone: 'Ni razvrščeno.',
            activateNone: 'Aktivirajte za odstranitev razvrščanja.',
            activateDescending: 'Aktivirajte za padajoče razvrščanje.',
            activateAscending: 'Aktivirajte za naraščajoče razvrščanje.',
          },
          sortBy: 'Razvrsti po',
        },
        dataFooter: {
          itemsPerPageText: 'Elementov na stran:',
          itemsPerPageAll: 'Vsi',
          nextPage: 'Naslednja stran',
          prevPage: 'Prejšnja stran',
          firstPage: 'Prva stran',
          lastPage: 'Zadnja stran',
          pageText: '{0}-{1} od {2}',
        },
        datePicker: {
          itemsSelected: '{0} izbranih',
          nextMonthAriaLabel: 'Naslednji mesec',
          nextYearAriaLabel: 'Naslednje leto',
          prevMonthAriaLabel: 'Prejšnji mesec',
          prevYearAriaLabel: 'Prejšnje leto',
        },
        noDataText: 'Ni podatkov na voljo',
        carousel: {
          prev: 'Prejšnji vizualni element',
          next: 'Naslednji vizualni element',
          ariaLabel: {
            delimiter: 'Carousel slide {0} of {1}',
          },
        },
        calendar: {
          moreEvents: '{0} več',
        },
        fileInput: {
          counter: '{0} datotek',
          counterSize: '{0} datotek ({1} skupno)',
        },
        timePicker: {
          am: 'AM',
          pm: 'PM',
        },
        pagination: {
          ariaLabel: {
            wrapper: 'Navigacija po strani',
            next: 'Naslednja stran',
            previous: 'Prejšnja stran',
            page: 'Pojdi na stran {0}',
            currentPage: 'Trenutna stran, stran {0}',
          },
        },
      },
    },
    current: 'sl',
  },
});
